import React from "react";
import { mapReleaseGroupToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetReleaseGroupColumns from "./ColumnDefinition/ReleaseGroupColumn/GetReleaseGroupColumns";

const ReleaseGroupTable = ({ data, page, limit, status }) => {
  const columns = GetReleaseGroupColumns({
    limit,
    page,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};
export default ReleaseGroupTable;
